import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
export function DisplayTagBadge({
  displayTagLabel
}) {
  return /*#__PURE__*/_jsx(Badge, {
    use: "koala",
    children: displayTagLabel
  });
}